import React from 'react'
import { Box } from '@mui/material'
import { Trans } from 'react-i18next'

const Logo = () => (
	<Box display="flex" alignItems="center" justifyContent="center" m="10px 0" minHeight="120px">
		<img
			src={`${process.env.PUBLIC_URL}/assets/images/new_prop_p.svg`}
			alt="prop-ai-logo"
			style={{ height: '65px' }}
		/>
		<span style={{ fontWeight: 'bold', fontSize: '65px', fontFamily: '"Eczar", serif', margin: '0 10px' }}>
			<Trans i18nKey="prop_ai" />
		</span>
	</Box>
)

type LoginLayoutProps = {
	children: React.ReactNode
	[key: string]: any
}

export default function LoginLayout({ children, ...props }: LoginLayoutProps) {
	return (
		<Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" m="10px 0" {...props}>
			<Logo />
			{children}
		</Box>
	)
}
